export interface ParsedNotification {
    email: string
    codeType: "swabcode" | "bloodcode"
    code: string
  }
  
  export const parseNotificationMessage = (message: string): ParsedNotification | null => {
    const regex = /email=([\w.-]+@[\w.-]+)\s+e\s+codice\s+(swabcode|bloodcode)=([\w\d]+)/i
    const match = message.match(regex)
  
    if (match) {
      return {
        email: match[1],
        codeType: match[2] as "swabcode" | "bloodcode",
        code: match[3],
      }
    }
  
    return null
  }